import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class Tibbit02Node extends BaseNode {
    constructor() {
        super();
        this.name = 'Tibbit 02';
        this.id = 'node_tibbit_02';
        this.description = 'RS232/422/485 port';

        this.inputs = [
            {
                name: 'Send Data',
                portId: 'serial_send',
                params: [
                    {
                        name: 'senddata',
                        dataType: TibboDataType.STRING,
                        default: '',
                    },
                ],
            },
        ];
        this.outputs = [
            {
                name: 'Data Available',
                portId: 'serial_data',
                params: [
                    {
                        name: 'serdata',
                        dataType: TibboDataType.STRING,
                    },
                ],
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const tibbit = project.getFeature(this.getSettingValue('FEATURE'));
        const tibbitName = tibbit?.getSettingValue('NAME');
        const functionName = `${tibbitName}_data_available`;
        const SERNAME = `SER_${tibbit?.getSettingValue('NAME')}`;
        const dataLocation = `${SERNAME}_data`;

        let links = project.getNodeLinks(this, 'serial_data');
        if (links.length > 0) {
            let dataCode = '';
            const link = links[0];
            dataCode += `'****${link.getSourceId()}****'\r\n`;
            blocks.push({
                location: 'on_ser_data_arrival',
                blockType: BlockType.CODE,
                template: `
    if ser.num=${SERNAME} then
        dim ${dataLocation} as string = ser.getdata(255)
        ${functionName}(${dataLocation})
    end if`,
            });
            blocks.push({
                location: 'DEVICE_TBS',
                id: functionName,
                blockType: BlockType.LOCATION,
                template: `
sub ${functionName}(serdata as string)
    ${dataCode}
end sub
            `,
            });
            blocks.push({
                location: 'GLOBAL_DECLARATIONS',
                id: `declare_${functionName}`,
                blockType: BlockType.CODE,
                template: `
'Tibbit 02 data available callback for ${tibbitName}
declare sub ${functionName}(serdata as string)`,
            });
        }


        links = project.getNodeLinks(this, 'serial_send');
        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];

            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `
    ser.num=${SERNAME}
    ser.setdata(${project.getNodeParameter(link, 'senddata')})
    ser.send()`,
            });
        }


        // for (let i = 0; i < links.length; i += 1) {
        //     const link = links[i];
        //     blocks.push({
        //         location: 'on_sys_timer',
        //         blockType: BlockType.CODE,
        //         template: `'****${link.getID()}****'`,
        //     });
        // }

        return blocks;
    }
}
